import {Component} from "react";

export default class SeoComponent extends Component {
    componentWillMount() {
        const {staticContext} = this.props;
        if (staticContext) {
            staticContext.seo = {};
        }
    }

    setMetaTags(title, description, extra = {}) {
        if (typeof document !== typeof undefined) {
            document.title = title;
        }

        const {staticContext} = this.props;
        if (staticContext) {

            staticContext.seo.title = title;
            staticContext.seo.description = description;

            for (let attr in extra) {
                if (extra.hasOwnProperty(attr)) {
                    staticContext.seo[attr] = extra[attr];
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/common/SeoComponent.js